export const setReferStoryAction = (story) => ({
  type: "SET_REFER_STORY",
  payload: story
});

export const setReferStoriesAction = (stories) => ({
  type: "SET_REFER_STORIES",
  payload: stories
});
